module.exports = __webpack_public_path__ + "img/img23.f87a9b00.png";